import { createI18n } from 'vue-i18n'

import { I18nInstance } from './utils/types'

import { handleLoadedLocales } from './utils/helpers'

/**
 * The app's locale, as a BCP-47 tag. Also handed to Reka's ConfigProvider in
 * App.vue, so its Intl-backed primitives (calendar, number field, collation)
 * format the same language the UI is written in. One knob, not two.
 */
export const DEFAULT_LOCALE = 'en'

let i18n: I18nInstance

export const i18nInit = async () => {
  const data = (import.meta as any).glob('../../**/*.json')

  const messages = await handleLoadedLocales(data)

  i18n = createI18n({
    locale: DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    messages,
    warnHtmlInMessage: 'off',
  })
}

export const useLocale = (prefix?: string) => {
  return {
    t: (path: string) => i18n?.global.t(`${prefix ? `${prefix}.` : ''}${path}`),
  }
}
